"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listCratesSync = exports.listCrates = exports.Crate = void 0;
const fs = __importStar(require("fs"));
const util_1 = __importDefault(require("util"));
const os_1 = __importDefault(require("os"));
const path_1 = __importDefault(require("path"));
const Crate_1 = __importDefault(require("./Crate"));
exports.Crate = Crate_1.default;
// Singleton for Serato Folder Path (I doubt it'll change during runtime)
const PLATFORM_DEFAULT_SERATO_FOLDER = path_1.default.join(os_1.default.homedir(), "Music", "_Serato_");
function getSubcratesFolder(seratoFolder = "") {
    return path_1.default.join(seratoFolder, "SubCrates");
}
/**
 * For each Serato Folder location, collect crates and returns a list
 * of all of these.
 */
function listCratesSync(seratoFolders = [PLATFORM_DEFAULT_SERATO_FOLDER]) {
    const allCrates = [];
    seratoFolders.forEach((seratoFolder) => {
        const subcratesFolder = getSubcratesFolder(seratoFolder);
        const crates = fs.readdirSync(subcratesFolder).map((x) => {
            const name = path_1.default.basename(x, ".crate");
            return new Crate_1.default(name, seratoFolder);
        });
        allCrates.push(...crates);
    });
    return allCrates;
}
exports.listCratesSync = listCratesSync;
function listCrates() {
    return __awaiter(this, arguments, void 0, function* (seratoFolders = [PLATFORM_DEFAULT_SERATO_FOLDER]) {
        const allCrates = [];
        for (const seratoFolder of seratoFolders) {
            const subcratesFolder = getSubcratesFolder(seratoFolder);
            const files = yield util_1.default.promisify(fs.readdir)(subcratesFolder);
            const crates = files.map((x) => {
                const name = path_1.default.basename(x, ".crate");
                return new Crate_1.default(name, seratoFolder);
            });
            allCrates.push(...crates);
        }
        return allCrates;
    });
}
exports.listCrates = listCrates;
const Serato = { Crate: Crate_1.default, listCrates, listCratesSync };
exports.default = Serato;
//# sourceMappingURL=index.js.map